import { v4 as uuidv4 } from 'uuid';

const STORAGE_KEY = 'whizr_install_id';

/** Cabeçalho que identifica este navegador no registro de buscas da API. */
export const INSTALL_HEADER = 'X-Install-Id';

let fallbackId = null;

/**
 * UUID deste navegador, criado na primeira visita. Identifica o visitante no
 * registro de buscas sem cookie de terceiro nem rastreamento: some ao limpar
 * os dados do site. Sem storage (bloqueado), um id por carga da página.
 */
export function getInstallId() {
    try {
        let id = localStorage.getItem(STORAGE_KEY);

        if (!id) {
            id = uuidv4();
            localStorage.setItem(STORAGE_KEY, id);
        }

        return id;
    } catch {
        fallbackId = fallbackId || uuidv4();
        return fallbackId;
    }
}
